export const ANY_TRIGGER_AUTHOR = 'Any';
export const FILTER_PIPELINES_SEARCH_DELAY = 200;
export const SCHEDULE_ORIGIN = 'schedule';
export const API_ORIGIN = 'api';
export const TRIGGER_ORIGIN = 'trigger';

export const CATALOG_TRACKING_LABEL = 'ci_cd_catalog_prompt';
export const GITLAB_UNIVERSITY_TRACKING_LABEL = 'gitlab_university_prompt';
export const MIGRATE_FROM_JENKINS_TRACKING_LABEL = 'migrate_from_jenkins_prompt';
